import LeadsAddedModule from "./leadsAddedModule";
import LeadsAddedSagas from "./redux/leadsAddedSagas";
import LeadsAddedReducer from "./redux/leadsAddedReducer";

export default {
  Component: LeadsAddedModule,
  moduleName: "leadsAdded",
  saga: LeadsAddedSagas(),
  reducer: LeadsAddedReducer
};
